import { Container, CustomImage as Image } from '..';
import styles from './Steps.module.css';

const articles = [
  {
    title: 'Choose Flex at Checkout',
    description:
      'At checkout, select “Flex | Pay with HSA/FSA”. If you are logged into Shop Pay, please select “checkout as guest”.',
    image: 'step-1.png',
  },
  {
    title: 'Pay using your HSA/FSA card',
    description:
      'Enter your HSA/FSA card details to complete the purchase. If you don’t have your FSA/HSA card, you can enter a credit or debit card. Some items including Ultrahuman Home will require you to confirm your eligibility through a brief questionnaire. Complete the questions and proceed to payment.',
    image: 'step-2.png',
  },
  {
    title: 'Get an itemized receipt',
    description:
      'Flex will email you an itemized receipt. Save this in case your HSA/FSA Administrator requires more information.',
    image: 'step-3.png',
  },
];

export const Steps = ({ className }: { className?: string }) => {
  return (
    <div className={className ? `${styles.root} ${className}` : styles.root}>
      <Container>
        <h4>How it works</h4>
        <div className={styles.articles}>
          {articles.map((article, index) => {
            return (
              <div className={styles.article} key={`article-${index}`}>
                <p className={styles.step}>step {index + 1}</p>
                <h5 className={styles.title}>{article.title}</h5>
                <p className={styles.description}>{article.description}</p>
                {/* Same asset at every width (CSS scales it) — was a
                    pointless useWindowSize img/Image swap that mis-rendered
                    on SSR. */}
                <Image
                  src={`web_v2/hsa-fsa/steps/v3/${article.image}`}
                  width="800"
                  height={301}
                  alt={article.title}
                />
              </div>
            );
          })}
        </div>
      </Container>
    </div>
  );
};
